import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

// Full URL: /admissions/unitsAndSchools.
// Internal admin/dev-only — not unit-scoped, not wrapped by AdmissionsShell.
export default store => ({
  path: "unitsAndSchools",
  component: withAsyncRouteLoading(() =>
    import(
      /* webpackChunkName: "admissions-admin-portal" */ "Admissions/features/AdminPortal/components/UnitsAndSchoolsPage"
    ).then(m => m.default)
  ),
});
